// extracted by mini-css-extract-plugin
export default {"hideTooltip":"k9-z","fadeIn":"l9-z","delay":"m9-z","recommendedSizeTooltip":"n9-z"};